import React, {
  useEffect,
  useState,
  useRef,
  useCallback,
  useMemo,
} from "react";
import Select from "../../../Select/Select.jsx";

import {
  handleReadingPaneLinkClick,
  handlePrintAllReadingPaneLinks,
} from "../../../ReadingPane/readingPane.js";

const Facets = ({
  serverData,
  selectedFacets,
  dictionary,
  mobileFacetsShown,
  setMobileFacetsShown,
  handleFacetChange,
  filteredSearch,
  resultsWrapperRef,
  isGated = false,
}) => {
  return (
    <>
      <div
        className={`search__filter-bar ${mobileFacetsShown ? "search__filter-bar--expanded" : ""}`}
      >
        <h4 onClick={e => setMobileFacetsShown(!mobileFacetsShown)}>
          Filter by:
          <i className="search__filter-bar-icon fas fa-caret-down"></i>
        </h4>
        <ul
          className={`search-facets ${mobileFacetsShown ? "search-facets--expanded" : ""}`}
        >
          {serverData.facets.map((facet, i) => {
            // if no facets or no values, skip rendering
            if (!facet.values || facet.values.length === 0) return;

            return (
              <li key={i}>
                <span className="search-facet__title">{facet.label}</span>

                {facet.id !== "state" && (
                  <ul className="search-facet__item-list">
                    {facet.values &&
                      facet.values.map((child, j) => (
                        <li className="search-facet__item" key={j}>
                          <label
                            className="search-facet__label"
                            htmlFor={`facet-${child.id}`}
                          >
                            <input
                              id={`facet-${child.id}`}
                              type="checkbox"
                              className="search-facet__checkbox"
                              value={child.id}
                              checked={selectedFacets[facet.id]?.includes(
                                child.id,
                              )}
                              onChange={() =>
                                handleFacetChange(facet.id, child.id)
                              }
                            />
                            <span className="search-facet__text">
                              {child.name} ({child.count})
                            </span>
                          </label>
                        </li>
                      ))}
                  </ul>
                )}

                {facet.id === "state" && (
                  <Select
                    componentName={`search-states`}
                    placeholder={`Locations`}
                    options={facet.values
                      .sort((a, b) => a.name.localeCompare(b.name))
                      .map(state => ({
                        label: `${state.name} (${state.count})`,
                        value: state.id,
                      }))}
                    callback={selected => {
                      handleFacetChange(facet.id, selected.value);
                    }}
                  />
                )}
              </li>
            );
          })}
          {serverData.results && !filteredSearch && !isGated && (
            <li className="search-facet--reading-pane">
              <span className="search-facet__title">Reading Pane</span>
              <div className="reading-pane__content js-reading-pane">
                <button
                  className="reading-pane__print-all js-print-all btn btn--primary"
                  onClick={e => {
                    e.preventDefault();
                    handlePrintAllReadingPaneLinks(
                      serverData.results.map(r => r.contentUrl + "?bodyOnly=1"),
                      {
                        documentListing: resultsWrapperRef.current,
                        onLoadingStart: () => {
                          resultsWrapperRef.current.scrollIntoView();
                        },
                      },
                    );
                  }}
                >
                  Print All
                </button>
              </div>
              {serverData.results.map((result, i) => (
                <a
                  key={i}
                  className="search-facets__reading-pane-link"
                  onClick={async e => {
                    e.preventDefault();
                    await handleReadingPaneLinkClick(
                      result.contentUrl + "?bodyOnly=1",
                      {
                        documentListing: resultsWrapperRef.current,
                        onLoadingStart: () => {
                          resultsWrapperRef.current.scrollIntoView();
                        },
                      },
                    );
                  }}
                >
                  {result.title}
                </a>
              ))}
            </li>
          )}
        </ul>
      </div>
    </>
  );
};

export default Facets;
